import axios from 'axios';
// axios.defaults.baseURL = "https://concept-clarifier-301795312179.europe-west4.run.app";

const TIMEOUT_GENERAL = 60000; // 1 min
const BASEURL = process.env.REACT_APP_CONCEPT_BASEURL;

export const createProposal = async (idea_idx, creative) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/write_proposal`, 
        { idea_idx: idea_idx, creative:creative }, 
        { timeout: TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.text
};

export const evaluateProposal = async (idea_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/evaluate_proposal`, 
        { idea_idx: idea_idx }, 
        { timeout: TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return  res.data.text;
};

export const enhanceProposal = async (idea_idx, review, creative) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/enhance_proposal`, 
        { idea_idx: idea_idx, prompt: review, creative: creative }, 
        { timeout: TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.text;
};


export const editProposal = async (idea_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/edit_proposal`, 
        { idea_idx: idea_idx }, 
        { timeout: TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.text;
};


export const createWorkPlan = async (idea_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/create_workplan`, 
        { idea_idx: idea_idx}, 
        { timeout: TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data;
};


export const searchPublications = async (idea_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/find_publications`, 
        { idea_idx: idea_idx}, 
        { timeout: 10*TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.publications
};


export const getPriorityText = async (idea_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/get_priority_topic`, 
        { idea_idx: idea_idx}, 
        { timeout: 10*TIMEOUT_GENERAL,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.text
};
